import { useState } from "react";

import {
  useAttributeReviewValueDomainSearchQuery,
  useSetPoolSellerTypingMutation,
} from "@/graphql/generated";

export function usePoolSearch() {
  const [text, setText] = useState("");
  const { data } = useAttributeReviewValueDomainSearchQuery(
    { query: text, limit: 10 },
    { enabled: text.trim().length > 1 },
  );
  const typing = useSetPoolSellerTypingMutation();
  return {
    text,
    setText,
    keys: (data?.attributeReviewValueDomainSearch.items ?? []).map(
      (item) => item.domainKey,
    ),
    setSellerTyping: (pool: string, allowed: boolean) =>
      typing.mutateAsync({ pool, allowed }),
  };
}

export type PoolSearch = ReturnType<typeof usePoolSearch>;
